import { Button, Checkbox, FormControlLabel, Typography } from "@mui/material";
import NextAction from "../../utils/NextAction";
import { Link } from "react-router-dom";

interface ContrlProps {
  restart: () => void;
  showNewStartPoint: () => void;
  showNewTargetPoint: () => void;
}

export default function Controls({
  restart,
  showNewStartPoint,
  showNewTargetPoint,
}: ContrlProps) {
  return (
    <div className="controls">
      <div>
        <Typography variant="h5" style={{ paddingBottom: 20 }}>
          Path Planning with Voronoi Diagram
        </Typography>
        <Typography style={{ paddingBottom: 10, textAlign: "left" }}>
          Now, we know how to build the Generalized Voronoi Diagram, but I can
          we do path planning based on it? You can see there are two points:
          start point and target point on the right side. In this page, we will
          show how to do motion planning on the Generalized Voronoi Diagram from
          start point to target point.
        </Typography>
        <Typography style={{ paddingBottom: 10, textAlign: "left" }}>
          Here is a restart button that allows you to reset at any time.
        </Typography>
        <Button variant={"contained"} sx={{ mb: 4 }} onClick={restart}>
          Restart
        </Button>
        <Typography variant="h6" style={{ paddingBottom: 10 }}>
          1. Find the New Start Point on the Generalized Voronoi Diagram
        </Typography>
        <Typography style={{ paddingBottom: 10, textAlign: "left" }}>
          Because the start point is not on the edge of the Voronoi diagram, we
          need a method to find suitable start point on it. We try to find the
          closest edge of obstacles or boundary from the start point first. In
          this example, the closest edge is the left boundary. Then, we draw a
          line which is perpendicular with the boundary and cross the start
          point. The intersection point on the Generalized Voronoi Diagram is
          the new start point.
        </Typography>
        <Button
          variant={"contained"}
          sx={{ mb: 4 }}
          onClick={showNewStartPoint}
        >
          Find new start point
        </Button>
        <Typography variant="h6" style={{ paddingBottom: 10 }}>
          2. Find the New Target Point on the Generalized Voronoi Diagram
        </Typography>
        <Typography style={{ paddingBottom: 10, textAlign: "left" }}>
          We do the same thing on target point. In this example, the closest
          edge is one edge of the polygon. Then, we draw a line which is
          perpendicular with the edge and cross the target point. The
          intersection point on the Generalized Voronoi Diagram is the new
          target point.
        </Typography>
        <Button
          variant={"contained"}
          sx={{ mb: 4 }}
          onClick={showNewTargetPoint}
        >
          Find new target point
        </Button>
        <Typography style={{ paddingBottom: 10, textAlign: "left" }}>
          Next, we will show how to do motion planning based on the{" "}
          <b>Generalized Voronoi Diagram</b> with a start point and a target
          point.
        </Typography>
        <Typography variant="h6" style={{ paddingBottom: 10 }}>
          3. Apply Path Finding Algorithm on the Voronoi Graph
        </Typography>
        <Typography style={{ paddingBottom: 10, textAlign: "left" }}>
          The new start point, new target point and the original Generalized
          Voronoi Diagram build the new graph. Then, we can use{" "}
          <Link to="/robotics/dijkstras">Dijkstra</Link> or{" "}
          <Link to="/robotics/astar-for-grids">A* algorithms</Link> to find the
          path.
        </Typography>
        <Typography style={{ paddingBottom: 10, textAlign: "left" }}>
          Congragulation! Now you know how to do path finding with Voronoi
          diagram. Next, we will introduce more advanced topic: Path Finding
          with Cell Decomposition.
        </Typography>
        <NextAction
          label={"Next: Path Planning with Cell Decomposition"}
          to="/robotics/cell-decomposition"
        />
      </div>
    </div>
  );
}
